function settaSezione(value){
  var val = value;
  $.ajax({
    type: "POST",
    async: false,
    url: "/cart.js",
    data: {"attributes[site_section]": val},
    dataType: "json"
  });
}
function settaBoutique(){
  settaSezione("boutique");
  setTimeout(function(){ 
    return;
  }, 500);
}
function settaLegacy(){
  settaSezione("legacy").delay(5000);
  setTimeout(function(){ 
    return;
  }, 500);
}

//
//Open Header Menu Overlay
//
function openMenu(){
  $(".overlay-menu").addClass("opened");
}

//
//Open Header Search
//
function openSearch(){
  $(".overlay-search").addClass("opened");
}

//
//Wildcard in search
//
$(document).ready(function () {
  
  /* ALESSANDRO ACHILLI: la search box conteneva lo stesso valore di quella non overlay cosi ho creato un nuovo elemento per la search in overlay mode */
  $('.searchOverlay-wrapper.container .search-bar-overlay , #SearchSection .search-bar-overlay').submit(function (event) {
    event.preventDefault();
    var self = this;

    var searchfield = $('.searchOverlay-wrapper.container .search_box--overlay, #SearchSection .search_box--overlay ');

    var strVal = $.trim(searchfield.val());

    var lastChar = strVal.slice(-1);
    if (lastChar == '*') {
      strVal = strVal.slice(0, -1);
    }

    searchfield.val(strVal + "*");
    self.submit();
  });
});

//
//Per i related blogs
//
function spostaSx(){
  var numeroElementi = $(".articles .col").length;
  var larghezzaElementi = $(".articles .col.active").css("flex-basis").replace('%', '');
  var posizioneAttiva = 1;
  for(i = 0; i < numeroElementi; i++){
    if( $(".articles .col").eq(i).hasClass("active") ) posizioneAttiva = i;
  }
  
  if(larghezzaElementi == 25){
    if( posizioneAttiva > 0){
      $(".articles .col").eq(posizioneAttiva).removeClass("active");
      posizioneAttiva = posizioneAttiva - 1;
      $(".articles .col").eq(posizioneAttiva).addClass("active");
      var pixel = larghezzaElementi * posizioneAttiva;
      $(".articles .col.first").css("margin-left", "-" + pixel + "%");
    }
  }

  else{
    if( posizioneAttiva > 0){
      $(".articles .col").eq(posizioneAttiva).removeClass("active");
      posizioneAttiva = posizioneAttiva - 1;
      $(".articles .col").eq(posizioneAttiva).addClass("active");
      var pixel = larghezzaElementi * posizioneAttiva;
      $(".articles .col.first").css("margin-left", "-" + pixel + "%");
    }
  }

}
function spostaDx(){ 
  var numeroElementi = $(".articles .col").length;
  var larghezzaElementi = $(".articles .col.active").css("flex-basis").replace('%', '');
  var posizioneAttiva = 1;
  for(i = 0; i < numeroElementi; i++){
    if( $(".articles .col").eq(i).hasClass("active") ) posizioneAttiva = i;
  }
  
  if(larghezzaElementi == 25){
    if( posizioneAttiva < ( numeroElementi - 4 ) ){
      $(".articles .col").eq(posizioneAttiva).removeClass("active");
      posizioneAttiva = posizioneAttiva + 1;
      $(".articles .col").eq(posizioneAttiva).addClass("active");
      var pixel = larghezzaElementi * posizioneAttiva;
      $(".articles .col.first").css("margin-left", "-" + pixel + "%");
    }
  }
  
  else{
    if( posizioneAttiva < ( numeroElementi - 2 ) ){
      $(".articles .col").eq(posizioneAttiva).removeClass("active");
      posizioneAttiva = posizioneAttiva + 1;
      $(".articles .col").eq(posizioneAttiva).addClass("active");
      var pixel = larghezzaElementi * posizioneAttiva;
      $(".articles .col.first").css("margin-left", "-" + pixel + "%");
    }
  }
  
}

//
//Per i popupper
//
function closePopupper(){
  $(".popupper-social").removeClass("opened");
  $(".popupper-info").removeClass("opened");
  $(".popupper-aiutarti").removeClass("opened");
  $(".popupper-servizi").removeClass("opened");
}

$(document).ready(function() {
  
  //
  // Order Filter Size
  //
  // $(".size_all").after($(".size_4xl")).after($(".size_3xl")).after($(".size_xxl")).after($(".size_xl")).after($(".size_l")).after($(".size_m")).after($(".size_s")).after($(".size_xs")).after($(".size_xxs"));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_5xl'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_4xl'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_3xl'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_xxl'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_xl'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_l'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_m'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_s'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_xs'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_xxs'));
  $('.sizeFilters .size_all').after($('.sizeFilters .size_3xs'));
  
  //
  //Eventi per i messaggi
  //
  $("#site__msg").on("msg:evaluate", function(event){ //Controlla se ha dentro qualcosa da mostrare e nel caso lo mostra!
    if( $(this).html() === '' ){
      $(this).removeClass("opened"); //nascondo msg
      $("body").off("click"); //rimuovo evento click dal body
      clearTimeout(chiusura); //fermo eventuali eventi di chiusura pendenti
    }
    else{
      $(this).addClass("opened"); //mostro msg
      chiusura = setTimeout(function(){ //istanzio un evento di chiusura temporizzato
        $("#site__msg").trigger("msg:clear");
      }, 6000);
      setTimeout(function(){ //dopo mezzo secondo dall'apertura metto al click ovunque la chiusura del messaggio
        $("body").on("click", function(){
          if( $("#site__msg").hasClass("opened") ){ //chiude il emssaggio solo se e' aperto
            $("#site__msg").trigger("msg:clear"); 
          }
        });
      }, 500);
    }
    
  }).on("msg:fill", function(event, content){ //Inserisce nel div dei messaggi un contenuto e poi valuta il div
    $(this).html(content);
    $(this).trigger("msg:evaluate");
    
  }).on("msg:clear", function(event){ //Svuota il div dei messaggi e poi valuta il div
    $(this).html("");
    $(this).trigger("msg:evaluate");
    
  });
  
  /// USES
  /// $("#site__msg").trigger("msg_evaluate");
  /// $("#site__msg").trigger("msg_fill", ["HTML VARIO"]);
  /// $("#site__msg").trigger("msg_clear");

  //
  //Overlay Closer
  //
  $(".overlay .x").click(function(){
    $(this).parents(".overlay").removeClass("opened");
  });
  
  //
  //Open Footer Social Links
  //
  $(".openSocial").click(function(evt){
    evt.preventDefault();
    if( $(".popupper-social").hasClass("opened") ){
      closePopupper();
    }
    else{
      closePopupper();
      $(".popupper-social").addClass("opened");
    }
  });
  
  //
  //Open Footer Social Links
  //
  $(".openInfo").click(function(evt){
    evt.preventDefault();
    if( $(".popupper-info").hasClass("opened") ){
      closePopupper();
    }
    else{
      closePopupper();
      $(".popupper-info").addClass("opened");
    }
  });
  
  //
  //Open Footer Social Links
  //
  $(".openAiutarti").click(function(evt){
    evt.preventDefault();
    if( $(".popupper-aiutarti").hasClass("opened") ){
      closePopupper();
    }
    else{
      closePopupper();
      $(".popupper-aiutarti").addClass("opened");
    }
  });
  
  //
  //Open Footer Social Links
  //
  $(".openServizi").click(function(evt){
    evt.preventDefault();
    if( $(".popupper-servizi").hasClass("opened") ){
      closePopupper();
    }
    else{
      closePopupper();
      $(".popupper-servizi").addClass("opened");
    }
  });

  //
  //Open Newsletter Overlay and permalink newsletter link
  //
  $(".openNewsletter, .open-newsletter--button").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-newsletter").toggleClass("opened");
  });
  
  //
  //Open Contact-us Overlay 
  //
  $(".openContactUs").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-contact-us").toggleClass("opened");
  });
  
  //
  //Open Contact-us Overlay 
  //
  $(".openVendorinfo, .link-about").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-vendorinfo").toggleClass("opened");
  });
  
  //
  //Open Size-Guide
  //
  
  /*
  $(".link-size-guide,  .mobile-size-guide .link-size-guide").click(function(evt){
    evt.preventDefault();
    window.open(
      'https://cdn.shopify.com/s/files/1/2261/4909/files/size_guide.pdf?10612140286093271399',
      '_blank'
    );
  });
 */
    
  //
  //Open Footer VendorInfo Overlay 
  //
  $(".openVendorinfo").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-vendorinfo").toggleClass("opened");
  });

  //
  //Open Store Switcher Overlay
  //
  $(".openSwitchStore").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-switchStore").toggleClass("opened");
  });
  
  //
  //Permalinks animations
  //
  $(".permalink--legacy, .permalink--boutique").mouseenter(function(){
    $(".switcher, .logo_switch").addClass("opened with-background");
  }).mouseleave(function(){
    $(".switcher, .logo_switch").removeClass("opened with-background");
  });
  $(".permalink--newsletter").mouseenter(function(){
    $(".permalink--newsletter .open-newsletter--button").addClass("with-background");
    $(".permalink--newsletter .stage_1").removeClass("opened");
    $(".permalink--newsletter .stage_2").addClass("opened");
  }).mouseleave(function(){
    $(".permalink--newsletter .open-newsletter--button").removeClass("with-background");
    $(".permalink--newsletter .stage_1").addClass("opened");
    $(".permalink--newsletter .stage_2").removeClass("opened");
  });
  
  //
  //Propago il click dall'icona al testo
  //
  $(".permalink").click(function(){
    $(this).find(".switcher")[0].click();
  });
  
  //
  //Save in cart the chosen area
  //
  $(".permalink--legacy a, .permalink--boutique a, .goToLegacy a, .goToBoutique a, .siteSwitcher li.legacy a, .siteSwitcher li.boutique a").click(function(event){
    var val = $(this).attr("data-section");
    settaSezione(val);
  });

  //
  //Link to home should remove the choice
  //
  $("#shopify-section-header .header-logo a").click(function(event){
  //  var val = null;
  //  settaSezione(val);
    /* ALESSANDRO ACHILLI: rimosso codice perchè andava a fare casini con l'header */
        window.location.assign('https://www.matchlesslondon.com/');

  });
  
  //
  //Link per cambio sito in overlay menu
  //
  if( $("body").hasClass("legacy") ){ 
    $(".siteSwitcher li.legacy").addClass("active");
  }
  else{
    $(".siteSwitcher li.boutique").addClass("active");
  }
  
  //
  //Per i related blogs
  //
  $(".relatedArticles .freccia-sx").click(function(){ 
    spostaSx(); 
  });
  $(".relatedArticles .freccia-dx").click(function(){ 
    spostaDx(); 
  });
  
  //
  //Funzioni per animare il menu mobile della buotique
  //
  $(".openServiziMobile").click(function(event){
    event.preventDefault();

    $(".stage-1").addClass("left");
    $(".stage-2").addClass("right");
    $(".stage-2.servizi").removeClass("left").removeClass("right");
    $(".mobileNavBar-close").removeClass("opened");
    $(".mobileNavBar-back").addClass("opened");
  });//Apre sottomenu SERVIZI
  $(".openAiutartiMobile").click(function(event){
    event.preventDefault();

    $(".stage-1").addClass("left");
    $(".stage-2").addClass("right");
    $(".stage-2.aiutarti").removeClass("left").removeClass("right");
    $(".mobileNavBar-close").removeClass("opened");
    $(".mobileNavBar-back").addClass("opened");
  });//Apre sottomenu AIUTO
  $(".openInfoMobile").click(function(event){
    event.preventDefault();

    $(".stage-1").addClass("left");
    $(".stage-2").addClass("right");
    $(".stage-2.info").removeClass("left").removeClass("right");
    $(".mobileNavBar-close").removeClass("opened");
    $(".mobileNavBar-back").addClass("opened");
  });//Apre sottomenu INFO
  $(".openSocialMobile").click(function(event){
    event.preventDefault();

    $(".stage-1").addClass("left");
    $(".stage-2").addClass("right");
    $(".stage-2.social").removeClass("left").removeClass("right");
    $(".mobileNavBar-close").removeClass("opened");
    $(".mobileNavBar-back").addClass("opened");
  });//Apre sottomenu SOCIAL
  $(".mobileNavBar-back").click(function(event){
    event.preventDefault();

    $(".stage-1").removeClass("left").removeClass("right");
    $(".stage-2").addClass("right");
    $(".mobileNavBar-close").addClass("opened");
    $(".mobileNavBar-back").removeClass("opened");
  });//Tasto BACK
  $(".mobileNavBar-close").click(function(event){
    event.preventDefault();

    $(".stage-1").removeClass("left").removeClass("right");
    $(".stage-2").addClass("right");
    $(".mobileNavBar-close").addClass("opened");
    $(".mobileNavBar-back").removeClass("opened");
    $(".overlay-menu").removeClass("opened");
  });//Tasto CLOSE

});

//
// Link negli articoli
//
$(".shop_link").click(function(){
  settaBoutique();
});


//
// PRODUCT PAGE
//
$(document).ready(function() {

  //
  //Open Shopper Page
  //
  $(".openShopper--button").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-shopper").toggleClass("opened");
  });

  //
  //Open Sharing Page
  //
  $(".openSharing--button").click(function(evt){
    evt.preventDefault();
    closePopupper();
    $(".overlay-sharing").toggleClass("opened");
  });
  
  
  $('.product-template-section .desktop-product-size-guide .link-size-guide').click(function() {
      $('.size-guide__modal-html .modal').css("display","flex");

  });


  $('.modal__close').click(function() {
    $('.size-guide__modal-html .modal').css("display","none");


  });
  
  
  
  
  /* size modal management qui vado ad utilizzare 2 tipologie di size guide, una classica che porta al pdf e l'altra alla modal size guide */

  $('.link-size-guide-pdf').click(function() {
    window.open(
      'https://cdn.shopify.com/s/files/1/2261/4909/files/size_guide.pdf?10612140286093271399',
      '_blank'
    );
  });
  
  
  
  /* SIZE GUIDE MODAL: qui vado a verificare se esiste un eleemnto che può essere generato soltato da una condizione liquid */
    if($('.size-guide__block--title').length ) {
    
    $('.link-size-guide').show();
    
    $('.link-size-guide-pdf').hide();
    
  } else {
    $('.link-size-guide').hide();
    
    $('.link-size-guide-pdf').show();
  }
  
  

});

//
// FINE PRODUCT PAGE
//



$(document).ready(function() {

  /* apre l'about page al click del logo presente nel footer */
    $(".openVendorinfo").click(function() {
       $('.container-fluid.overlay-vendorinfo.overlay').addClass('opened', 1000);

      //window.location.assign('https://www.matchlesslondon.com/');
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if ($(mutation.target).hasClass('mwCMB__text') && $(mutation.target).text().trim()) {
          $('.site-header__free-space').text($('#mwCMB .mwCMB__text').text());
          observer.disconnect();
        }
      });
    });

    var config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    };

    observer.observe(document.body, config);
  
  
  //OneUp
  var tti = setInterval(function() {
  if($('.__seguno-banner-text').length > 0) {
  	$('<button class="open-popup-newsletter">Subscribe</button>').appendTo('.__seguno-banner-text');
    $('<div class="close-newsletter"></div>').prependTo('.__seguno-discount');
      clearTimeout(tti);
    }
}, 200);
  
  var tti2 = setInterval(function() {
  if($('.site-header__free-space').text().length > 0) {
    $('<div class="close-header"></div>').appendTo('.site-header__free-space');
      clearTimeout(tti2);
    }
}, 200);
  
  $('body').on('click', '.open-popup-newsletter', function() {
  	$('.overlay-newsletter.overlay').addClass('opened');
  });
  
  $('body').on('click', '.close-newsletter', function() {
  	$('.__seguno-banner-container').attr("style", "display: none !important");
  });
  
  $('body').on('click', '.close-popup-newsletter-new', function() {
  	$('.popup-newsletter-new').attr("style", "display: none !important");
  });
  
  $('body').on('click', '.close-header', function() {
  	$('.site-header__free-space').attr("style", "display: none !important");
  });
  
  $('.fulltemplate-collection #collectionFilters h2').on('click', function() {
    $(this).parent().siblings().children().removeClass('open');
    $(this).toggleClass('open');
    $(this).siblings('.advanced-filters').toggleClass('open');
  });
  
  //sessionStorage.removeItem("show_popup_newsletter_new");
  /**
   * Funzioni di utilità per gestire i cookie
   */
  function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function setCookie(name, value, options = {}) {

    options = {
      path: '/',
      // add other defaults here if necessary
      ...options
    };
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
  
    var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (var optionKey in options) {
      updatedCookie += "; " + optionKey;
      var optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
  
    document.cookie = updatedCookie;
  }


  var showNewsletterPopupCookie = getCookie('show_popup_newsletter_new');
  if(showNewsletterPopupCookie !== 'false') {
    setTimeout(function() {
      $('.popup-newsletter-new').show();
      setCookie("show_popup_newsletter_new", "false", {'max-age': 60 * 60 * 24 * 30});
    }, 20000);
  }
  
  
  
});

